import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  levelOfServicesList: [],
  getLevelOfServicesListWithProviders: []
};
const levelOfServicesReducer = createSlice({
  name: 'levelOfServices',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getLevelOfServicesList(state, action) {
      console.log('action.payload', action.payload);
      return {
        ...state,
        levelOfServicesList: action.payload?.data
      };
    },
    getLevelOfServicesListWithProviders(state, action) {
      return {
        ...state,
        levelOfServicesListWithProviders: action.payload?.data || []
      };
    },
    isActive(state, action) {
      const newLevelOfServicesList = [...state.levelOfServicesList].map(
        (item) => {
          if (item.id === action.payload) {
            return { ...item, inactive: !item.inactive };
          } else return item;
        }
      );
      return {
        ...state,
        levelOfServicesList: newLevelOfServicesList
      };
    }
  }
});

export default levelOfServicesReducer.reducer;

export const levelOfServicesActions = levelOfServicesReducer.actions;

export const createLevelOfService = (role) => async () => {
  try {
    const res = await api.post(`api/LevelOfService`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editLevelOfService = (id) => async (dispatch) => {
  try {
    const res = await api.put(`api/LevelOfService/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(levelOfServicesActions.isActive(id));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getLevelOfServicesAction = (data) => async (dispatch) => {
  dispatch(levelOfServicesActions.setLoading(true));
  try {
    const res = await api.get(`api/LevelOfService`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(levelOfServicesActions.getLevelOfServicesList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(levelOfServicesActions.setLoading(false));
  }
};

export const getLevelOfServicesListWithProviders =
  (data) => async (dispatch) => {
    dispatch(levelOfServicesActions.setLoading(true));
    try {
      const res = await api.get(`api/LevelOfService/SharedWithProvider`, {
        params: data
      });
      if (res.status === 200 && res?.data) {
        dispatch(
          levelOfServicesActions.getLevelOfServicesListWithProviders(res.data)
        );
        return Promise.resolve(res?.data);
      }
    } catch (errors) {
      return Promise.reject(errors.response?.data);
    } finally {
      dispatch(levelOfServicesActions.setLoading(false));
    }
  };

export const removeLevelOfServices =
  (id, setRemoveDialog) => async (dispatch) => {
    try {
      const res = await api.delete(`api/LevelOfService/${id}`);
      if (res.status === 200 && res?.data) {
        dispatch(getLevelOfServicesAction()).catch((error) => formErrorsHandle(error, {}));
        setRemoveDialog('');
        toast.success('Removed successfully!!!');
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
    }
  };
